import React from 'react';

const NotMatch = () => (
  <div className="no-match">
    <h3>Whoops! Page not found!</h3>
  </div>
);

export default NotMatch;
